<mat-sidenav-container class="sidenav-container">
  <mat-sidenav
    position="end"
    style="width: 60%; max-width: 270px"
    #drawer
    class="sidenav mat-elevation-z8"
    fixedInViewport
    [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'"
    [mode]="'over'"
    id="landing-sidenav"
  >
    <app-landing-user-menu
      [isLoggedIn]="isAuthenticated"
      [isHandset$]="isHandset$"
      [user]="userData"
    ></app-landing-user-menu>
  </mat-sidenav>
  <mat-sidenav-content
    id="sidenavContent"
    style="overflow: hidden"
    class="mat-elevation-z2"
  >
    <user-panel-toolbar
      class="user-panel-toolbar"
      (drawerToggle)="drawer.toggle()"
      [isHandSet]="(isHandset$ | async)!"
    ></user-panel-toolbar>

    <div class="user-panel-container">
      <!-- Content for sidenav -->

      <div class="ziraxi-outlet">
        <!-- <landing-toolbar
          [orders]="orders"
          [isAuthenticated]="isAuthenticated"
          (openSidenav)="drawer.toggle()"
          *ifIsBrowser
        ></landing-toolbar> -->

        <div id="banner-wrapper">
          <div id="appBanner" fxLayout="row" fxLayoutAlign="center center">
            <!-- <div class="bg-color"></div> -->
            <img
              src="assets/image/banner-white-bg-2.svg"
              alt="https://ziraxi.com/"
            />
          </div>
        </div>

        <div class="container">
          <section id="services-wrapper">
            <div
              id="appActions"
              fxLayout="row "
              fxLayoutAlign="space-between center"
            >
              <div class="action-buttons">
                <div
                  class="action-button"
                  fxLayout="column"
                  fxLayoutAlign="space-between center"
                  (click)="scrollToLandingOutlet()"
                >
                  <button
                    [routerLinkActiveOptions]="{ exact: true }"
                    [routerLinkActive]="['activated']"
                    [routerLink]="['/black-and-white-print']"
                    mat-raised-button
                  >
                    <img
                      ngSrc="assets/new-icons/new-printer.svg"
                      width="40"
                      height="40"
                      class="icon"
                      alt="پرینت"
                    />

                    <div class="name">
                      <span>پرینت</span>
                    </div>
                  </button>
                </div>

                <div
                  class="action-button"
                  fxLayout="column"
                  fxLayoutAlign="space-between center"
                  (click)="scrollToLandingOutlet()"
                >
                <div class="action-tag" *ifIsBrowser>
                  بزودی
                  <svg
                    width="8"
                    height="9"
                    viewBox="0 0 8 9"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    class="tag-angle"
                  >
                    <path d="M8 9L0 0H8V9Z"></path>
                  </svg>
                </div>
                  <button
                    [routerLinkActiveOptions]="{ exact: true }"
                    [routerLinkActive]="['activated']"
                    [routerLink]="['thesis-binding']"
                    mat-raised-button
                    class="disabled"
                  >
                    <img
                      ngSrc="assets/new-icons/new-mortar-board.svg"
                      width="40"
                      height="40"
                      class="icon"
                      alt="پایان‌نامه"
                    />
                    <div class="name">
                      <span> پایان‌نامه </span>
                    </div>
                  </button>
                </div>

                <div
                  class="action-button"
                  fxLayout="column"
                  fxLayoutAlign="space-between center"
                >
                  <div class="action-tag" *ifIsBrowser>
                    بزودی
                    <svg
                      width="8"
                      height="9"
                      viewBox="0 0 8 9"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      class="tag-angle"
                    >
                      <path d="M8 9L0 0H8V9Z"></path>
                    </svg>
                  </div>
                  <button class="action-button disabled" mat-raised-button>
                    <img
                      ngSrc="assets/new-icons/new-file-share-icon.svg"
                      width="40"
                      height="40"
                      class="icon"
                      alt="اشتراک فایل"
                    />
                    <div class="name">
                      <span>اشتراک فایل</span>
                    </div>
                  </button>
                </div>

                <div
                  class="action-button"
                  fxLayout="column"
                  fxLayoutAlign="space-between center"
                >
                  <div class="action-tag" *ifIsBrowser>
                    بزودی
                    <svg
                      width="8"
                      height="9"
                      viewBox="0 0 8 9"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      class="tag-angle"
                      data-v-64c1c72b=""
                    >
                      <path d="M8 9L0 0H8V9Z" data-v-64c1c72b=""></path>
                    </svg>
                  </div>
                  <button class="action-button disabled" mat-raised-button>
                    <img
                      ngSrc="assets/new-icons/new-booklet-icon.svg"
                      width="40"
                      height="40"
                      class="icon"
                      alt="مرکز جزوه"
                    />
                    <div class="name">
                      <span>مرکز جزوه</span>
                    </div>
                  </button>
                </div>

                <div
                  class="action-button"
                  fxLayout="column"
                  fxLayoutAlign="space-between center"
                >
                  <div class="action-tag" *ifIsBrowser>
                    بزودی
                    <svg
                      width="8"
                      height="9"
                      viewBox="0 0 8 9"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      class="tag-angle"
                      data-v-64c1c72b=""
                    >
                      <path d="M8 9L0 0H8V9Z" data-v-64c1c72b=""></path>
                    </svg>
                  </div>
                  <button class="action-button disabled" mat-raised-button>
                    <img
                      ngSrc="assets/new-icons/new-telegram-icon.svg"
                      width="40"
                      height="40"
                      class="icon"
                      alt="ربات تلگرام"
                    />
                    <div class="name">
                      <span>ربات تلگرام</span>
                    </div>
                  </button>
                </div>
              </div>
            </div>
            <!-- Main ziraxi animation -->
          </section>
        </div>

        <div>
          <section
            #landingContainer
            id="appContainer"
            fxLayout="column"
            fxLayoutAlign.gt-md="center"
          >
            <div id="serviceTitleWrapper"></div>
            <div
              class="container d-flex align-items-center justify-content-center justify-content-md-start position-relative"
              id="titles"
            >
              <div class="title-holder d-flex flex-column">
                <ng-container *ngIf="config; else headerTemplate">
                  <h1
                    class="main-title"
                    [innerHTML]="config.header + '<br>' + config.desc"
                  ></h1>
                  <!-- <h3 class="header-description" [innerHTML]="config.desc"></h3> -->
                </ng-container>
                <ng-template #headerTemplate>
                  <h1 class="main-title">
                    سامانه چاپ آنلاین زیراکسی
                    <br />
                    ارائه‌دهنده پرینت ارزان و باکیفیت
                  </h1>
                </ng-template>
              </div>
              <div class="animation-container" *ifIsBrowser>
                <app-logo-animation
                  animationId="mainAnimation"
                  *ngIf="!(isMobile | async)"
                ></app-logo-animation>
              </div>
              <!-- Mobile view logo -->
              <!-- <div style="flex-grow: 1">
                <img
                  class="mobile-view-logo"
                  ngSrc="assets/image/Logo.svg"
                  width="200"
                  height="100"
                  alt="Ziraxi Printer Logo"
                />
              </div> -->
            </div>
            <!-- Used for scrolling -->
            <div class="hidden-wrapper" #hiddenWrapper></div>
            <router-outlet></router-outlet>
            <!-- <section *ngIf="config" class="dynamic-content"> -->
            <!-- <app-dynamic-content
              [config]="config"
              (scroll)="scrollToLandingOutlet()"
            ></app-dynamic-content> -->
            <!-- </section> -->
          </section>
        </div>

        <div
          id="landingContent"
          fxLayout="column"
          fxLayoutAlign="center center"
        >
          <section class="why-ziraxi">
            <div class="background">
              <div class="container items-holder">
                <h2 class="title">چرا زیراکسی!؟</h2>
                <div class="items">
                  <div class="block mat-elevation-z3">
                    <img
                      ngSrc="assets/image/docs/block-1.svg"
                      alt="icon 1"
                      width="90"
                      height="100"
                    />
                    <h5>تضمین کیفیت</h5>
                    <div>
                      بهترین کیفیت چاپ به همراه ضمانت برگشت وجه به صورت آنی
                    </div>
                  </div>
                  <div class="block mat-elevation-z3">
                    <img
                      ngSrc="assets/image/docs/block-2.svg"
                      alt="icon 2"
                      width="90"
                      height="100"
                    />
                    <h5>80% زیر قیمت بازار</h5>
                    <div>
                      انواع پرینت 80% زیر قیمت تصویب شده در نرخ‌نامه اتحادیه
                      اصناف
                    </div>
                  </div>
                  <div class="block mat-elevation-z3">
                    <img
                      ngSrc="assets/image/docs/block-3.svg"
                      alt="icon 3"
                      width="90"
                      height="100"
                    />
                    <h5>ارسال سریع</h5>
                    <div>ارسال طی 24 ساعت روز کاری در تهران و اصفهان</div>
                  </div>
                  <div class="block mat-elevation-z3">
                    <img
                      ngSrc="assets/image/docs/block-4.svg"
                      alt="icon 4"
                      width="90"
                      height="100"
                    />
                    <h5>راحت و آسان</h5>
                    <div>
                      پنل کاربری ساده و کامل به همراه ربات تلگرام اختصاصی
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div>
              <div class="background-white" *ngIf="!config">
                <div class="description">
                  <p>
                    در دنیایی که شاهد تغییرات گسترده در حوزه دیجیتال هستیم، از
                    جمله خدماتی که کاربران زیادی را به خود جلب کرده، چاپ آنلاین
                    است. زیراکسی یکی از معتبر‌ترین مراکز چاپ آنلاین است که با
                    ایجاد وب‌سایتی کاربردی، خدمات منحصربه‌فردی به مشتریان خود
                    ارائه می‌کند. از جمله این خدمات می‌توان به
                    <a class="primary-text" routerLink="/black-and-white-print"
                      >پرینت سیاه ‌و سفید</a
                    >،
                    <a class="primary-text" routerLink="/combined-printing"
                      >پرینت ترکیبی</a
                    >،
                    <a class="primary-text" routerLink="/full-color-print"
                      >پرینت تمام‌ رنگی</a
                    >،
                    <a class="primary-text" routerLink="/half-color-print"
                      >پرینت نیمه رنگی</a
                    >،
                    <a class="primary-text" routerLink="/thesis-binding"
                      >پرینت و صحافی پایان‌ نامه</a
                    >
                    و
                    <a class="primary-text" routerLink="/thesis-editing"
                      >ویرایش پایان‌ نامه</a
                    >
                    اشاره کرد. مخاطبین زیراکسی، همه افرادی هستند که برای سفارش
                    <a class="primary-text" routerLink="/booklet-print"
                      >چاپ جزوه</a
                    >
                    و کتاب‌های خود نیاز به مجموعه‌ای معتبر دارند. همچنین در این
                    مجموعه امکان عقد قرارداد با مؤسسات، مدارس و سازمان‌ها نیز
                    وجود دارد. با زیراکسی به‌راحتی و تنها با چند کلیک،
                    <a class="primary-text" routerLink="/cheap-print"
                      >پرینت ارزان</a
                    >
                    باکیفیت داشته باشید و در زمان و انرژی خود صرفه‌جویی کنید.
                  </p>
                </div>
              </div>
            </div>
          </section>
        </div>
        <img
          *ngIf="isMobile | async"
          class="mt-4"
          ngSrc="assets/image/mobile/shopping-route.webp"
          alt="مسیر خرید"
          fill
          style="height: auto; position: relative"
        />
        <!-- <div class="container pb-5 referral-container">
          <div class="referral-wrapper">
            <img
              class="my-5"
              src="assets/image/referral-wrapper.webp"
              fill
              alt="ریفرال زیراکسی"
            />
            <div class="referral-text-wrapper">
              <div class="referral-heading blue-text">
                ما رو به <span class="red-text">دوستات</span> معرفی کن و هدیه
                بگیر
              </div>
              <div class="referral-text blue-text" *ngIf="!(isMobile | async)">
                به ازای هر نفر که با لینک اختصاصی شما ثبت‌نام و اولین سفارش رو
                ثبت کنه، 15 امتیاز معادل
                <span class="red-text">15 صفحه پرینت</span> هدیه می‌گیری
              </div>
            </div>
            <button class="btn btn-red">دریافت لینک</button>
          </div>
        </div> -->

        <img
          *ngIf="!(isMobile | async)"
          fill
          style="height: auto; position: relative"
          ngSrc="assets/image/shopping-route.svg"
          alt="مسیر خرید"
        />
        <div class="container p-0 d-flex flex-column">
          <div class="w-100 d-flex contract">
            <div *ngIf="!(isMobile | async)" class="col-md-7 p-0">
              <img
                ngSrc="assets/image/contract.svg"
                fill
                style="height: 100%; position: relative"
                alt=" آماده همکاری و عقد قرارداد با مدارس، سازمان‌ها و ادارات"
              />
            </div>
            <div class="col-md-5 col-12 content py-4 pe-3 ps-0">
              <div class="bg-white contract-content w-100 py-5 px-3">
                <h3 class="text-center mb-4">همکاری با سازمان‌‌ها و مدارس</h3>
                <div class="px-4">
                  <span class="fs-4 fw-bold">
                    مجموعه زیراکسی،
                    <span class="red-text fs-4 fw-bold"> تخفیف ویژه‌ای </span>
                    برای سازمان‌ها و مدارس در نظر گرفته و آماده عقد قرارداد با
                    شماست.
                    <span class="mt-3 d-block fs-4 fw-bold">
                      برای کسب اطلاعات بیشتر شماره تماس خود را ثبت کنید.
                    </span>
                  </span>
                </div>
              </div>
              <div class="d-flex mt-4 px-4">
                <input
                  dir="ltr"
                  placeholder="0913xxxxxxxx"
                  type="text"
                  class="form-control ms-3"
                />
                <button class="btn btn-white col-3">ثبت</button>
              </div>
            </div>
          </div>

          <hr class="mt-5 w-100 d-none d-sm-block" />
          <app-question [config]="config"></app-question>
        </div>

        <app-footer>
          <div>
            <p class="text-justify">
              سفارش چاپ آنلاین مطمئن، نیازمند چاپخانه‌ای است که بتواند خدمات
              متنوع چاپ را با بالا‌ترین کیفیت و مناسب‌ترین قیمت، به مخاطبان خود
              ارائه کند و سفارش‌ها را در کم‌ترین زمان ممکن به دست مشتریان
              برساند. زیراکسی مجموعه‌ای پویا و پیشرو در زمینه چاپ افست و چاپ
              دیجیتال است که تمامی خدمات خود را به‌صورت آنلاین به مشتریان ارائه
              می‌کند. این شرکت با تکیه بر نیروهای متخصص و مجرب و همچنین
              چاپخانه‌ای پیشرفته، انقلابی بزرگ در حوزه چاپ آنلاین ایجاد کرده
              است. زیراکسی با ارائه خدماتی کم‌نظیر و باکیفیت، توانسته توجه و
              اعتماد کاربران زیادی را جلب و آن‌ها را به مشتریان ثابت خود تبدیل
              کند.
            </p>
            <p class="text-justify">
              <span class="footer-sub-title"
                >زیراکسی چه خدماتی ارائه می‌دهد؟</span
              >
              در مجموعه زیراکسی، خدمات متنوعی ارائه می‌شود که افراد و سازمان‌های
              مختلف می‌توانند از آن‌ها استفاده کنند. این خدمات را می‌توان به چند
              گروه اصلی دسته‌بندی کرد:
            </p>
            <p class="text-justify">
              <span class="footer-sub-title">خدمات پرینت</span>
              افراد و سازمان‌ها در سراسر کشور به‌راحتی می‌توانند از خدمات
              <a class="footer-links" routerLink="online-print">پرینت آنلاین</a>
              زیراکسی استفاده کنند. این خدمات شامل
              <a class="footer-links" routerLink="black-and-white-print"
                >پرینت سیاه ‌و سفید</a
              >،
              <a class="footer-links" routerLink="combined-printing"
                >پرینت ترکیبی</a
              >
              و
              <a class="footer-links" routerLink="full-color-print"
                >پرینت رنگی</a
              >
              است. زیراکسی برای ‌اینکه بتواند
              <a class="footer-links" routerLink="half-color-print"
                >پرینت رنگی ارزان</a
              >
              به مشتریان خود ارائه دهد، این نوع پرینت را در دو بخش تمام‌ رنگی و
              نیمه‌رنگی ارائه کرده است. این مجموعه در تلاش است که خدمات خود را
              در پایین‌ترین قیمت و بالا‌ترین کیفیت به کاربران ارائه کند تا
              مشتریان بتوانند
              <a class="footer-links" routerLink="cheap-print">پرینت ارزان</a> و
              باکیفیت را تجربه کنند.
            </p>
            <p class="text-justify">
              <span class="footer-sub-title">خدمات دانشجویی</span>
              زیراکسی خدمات ویژه دیگری مانند
              <a class="footer-links" routerLink="thesis-editing"
                >ویرایش پایان‌نامه</a
              >
              و
              <a class="footer-links" routerLink="thesis-binding"
                >صحافی پایان‌نامه</a
              >
              را با قیمتی مناسب به دانشجویان سراسر کشور ارائه کرده است. با وجود
              پنل کاربردی این مجموعه، دانشجویان می‌توانند سفارش‌های خود را
              به‌راحتی و بدون دغدغه ثبت کرده و ویرایش و صحافی پایان‌نامه خود را
              به زیراکسی بسپارند.
            </p>
          </div>
        </app-footer>

        <!-- Discounts -->
        <!-- <div id="discounts" *ngIf="router.url !== '/document'">
                <shared-discount-container></shared-discount-container>
            </div> -->
      </div>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
